export default __webpack_public_path__ + "static/media/026-tractor.67cbc06f.svg";